module.exports = __webpack_public_path__ + "img/promotion.bc5aff4b.svg";